<template>
  <div
    v-if="internalValue"
    id="applicant-personal-data-form"
    class="applicant-show-form"
  >
    <div class="vx-row">
      <div class="vx-col w-full flex flex-wrap flex-row content-start">
        <h2 class="w-full">Corona Infos</h2>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/3 mt-auto">
            <DataInput
              :value="internalValue.covidVaccination.state"
              type="select"
              class="w-full mt-4"
              label="Immunisierung"
              name="immunizationoption"
              :options="immunizationOptions"
              @input="e => updateValue('covidVaccination', e, 'state')"
            />
          </div>
          <div class="vx-col w-full md:w-1/3 mt-auto">
            <DataInput
              :value="
                internalValue.covidVaccination
                  .lastVaccinationForCompleteCoverage
              "
              :required="!!vaccinationDateRequired"
              :validation-rules="vaccinationDateRequired"
              type="date"
              class="w-full mt-4"
              label="Letzte impfung für vollständigen Impschutz"
              name="lastVaccinationDate"
              @input="
                e =>
                  updateValue(
                    'covidVaccination',
                    e,
                    'lastVaccinationForCompleteCoverage'
                  )
              "
            />
          </div>
          <div class="vx-col w-full md:w-1/3 mt-auto">
            <DataInput
              :value="internalValue.covidVaccination.lastPCRTestDateForRecovery"
              type="date"
              class="w-full mt-4"
              label="Letzter PCR-Test für genesenen Zustand"
              name="lastTestDate"
              :required="!!testDateRequired"
              :validation-rules="testDateRequired"
              @input="
                e =>
                  updateValue(
                    'covidVaccination',
                    e,
                    'lastPCRTestDateForRecovery'
                  )
              "
            />
          </div>
        </div>
        <h2 class="w-full mt-3 mb-3">Persönliche Daten</h2>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              :value="internalValue.salutation"
              required
              validation-rules="required"
              type="select"
              :options="salutations"
              class="w-full"
              label="Anrede"
              name="salutation"
              @input="e => updateValue('salutation', e)"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              :value="internalValue.title"
              class="w-full"
              label="Titel"
              name="title"
              @input="e => updateValue('title', e)"
            />
          </div>
          <div class="vx-col w-full md:w-1/3">
            <DataInput
              :value="internalValue.salutationType"
              type="select"
              :options="salutationTypes"
              class="w-full"
              label="Anredeform"
              name="salutationType"
              @input="e => updateValue('salutationType', e)"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              :value="internalValue.firstName"
              required
              validation-rules="required"
              class="w-full mt-4"
              label="Vorname"
              name="firstName"
              @input="e => updateValue('firstName', e)"
            />
          </div>
          <div class="vx-col w-full md:w-1/2">
            <DataInput
              :value="internalValue.lastName"
              required
              validation-rules="required"
              class="w-full mt-4"
              label="Nachname"
              name="lastName"
              @input="e => updateValue('lastName', e)"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div
            v-if="
              internalValue.contactData.address &&
                internalValue.contactData.address.street &&
                internalValue.contactData.address.city
            "
            class="vx-col w-full"
          >
            <h3 class="mt-6">
              Adresse
              <a
                :href="
                  `https://www.google.de/maps/dir/` +
                    internalValue.contactData.address.street +
                    `,+` +
                    internalValue.contactData.address.city +
                    `/`
                "
                class="route-planer-btn"
                title="Routenplaner öffnen"
                target="_blank"
                ><i class="fal fa-map-marked-alt"></i
              ></a>
            </h3>
          </div>
          <div class="vx-col w-full mb-2">
            <DataInput
              :value="internalValue.contactData.address"
              street-not-required
              type="address"
              class="w-full"
              label="Adresse"
              name="address"
              @input="e => updateValue('contactData', e, 'address')"
            />
          </div>
        </div>
      </div>
      <div class="vx-col mt-8 lg:mt-0 w-full">
        <DataInput
          :value="internalValue.imageID"
          type="image"
          class="mb-5"
          label="Bild"
          name="imageID"
          @input="e => updateValue('imageID', e)"
        />

        <h2 class="w-full">Private Daten</h2>

        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <DataInput
              :value="internalValue.contactData.telephone"
              type="tel"
              class="w-full mt-4 pr-3"
              label="Telefon"
              name="telephone"
              @input="e => updateValue('contactData', e, 'telephone')"
            />
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <DataInput
              :value="internalValue.contactData.telephoneMobile"
              type="tel"
              class="w-full mt-4 pr-3"
              label="Telefon Mobil"
              name="telephoneMobile"
              @input="e => updateValue('contactData', e, 'telephoneMobile')"
            />
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <DataInput
              :value="internalValue.contactData.email"
              type="email"
              validation-rules="email"
              class="w-full mt-4 pr-3"
              label="E-Mail"
              name="email"
              @input="e => updateValue('contactData', e, 'email')"
            />
            <div v-if="applicantsPage && applicantsPage.results">
              <div
                v-for="applicant of applicantsPage.results"
                :key="applicant.id"
              >
                <router-link
                  target="_blank"
                  :to="{ name: 'applicant.edit', params: { id: applicant.id } }"
                >
                  {{ applicant.number }} - {{ applicant.firstName }}
                  {{ applicant.lastName }}
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full mt-4">
            <DataInput
              :value="internalValue.birthday"
              type="date"
              label="Geburtsdatum"
              name="birthday"
              @input="e => updateValue('birthday', e)"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full mt-4">
            <DataInput
              :value="internalValue.birthplace"
              label="Geburtsort"
              name="birthplace"
              @input="e => updateValue('birthplace', e)"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <DataInput
              :value="internalValue.civilStatus"
              type="select"
              :options="civilStates"
              class="mt-4 pr-3"
              label="Familienstand"
              name="salutationType"
              @input="e => updateValue('civilStatus', e)"
            />
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <DataInput
              :value="internalValue.kids"
              type="number"
              class="w-full mt-4 pr-3"
              label="Kinder"
              name="kids"
              @input="e => updateValue('kids', e)"
            />
          </div>
          <div class="vx-col w-full lg:w-9/12">
            <DataInput
              :value="internalValue.nationality"
              type="select"
              :options="Countries"
              class="mt-4 pr-3"
              label="Staatsangehörigkeit"
              name="nationality"
              @input="e => updateValue('nationality', e)"
            />
          </div>
          <div class="vx-col w-full lg:w-3/12">
            <DataInput
              :value="internalValue.residentPermit"
              type="bool"
              class="mt-4 pr-3"
              label="Aufenthaltserlaubnis"
              name="residentPermit"
              @input="e => updateValue('residentPermit', e)"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="vx-row mt-8">
      <div class="vx-col lg:w-1/2 w-full">
        <h2>Firma</h2>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <DataInput
              :value="internalValue.contactDataCompany.telephone"
              type="tel"
              class="w-full mt-4 pr-3"
              label="Telefon"
              name="telephone"
              @input="e => updateValue('contactDataCompany', e, 'telephone')"
            />
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <DataInput
              :value="internalValue.contactDataCompany.telephoneMobile"
              type="tel"
              class="w-full mt-4 pr-3"
              label="Telefon Mobil"
              name="telephoneMobile"
              @input="
                e => updateValue('contactDataCompany', e, 'telephoneMobile')
              "
            />
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <DataInput
              :value="internalValue.contactDataCompany.email"
              type="email"
              validation-rules="email"
              class="w-full mt-4 pr-3"
              label="E-Mail"
              name="email"
              @input="e => updateValue('contactDataCompany', e, 'email')"
            />
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="vx-row lg:mt-3">
      <div class="vx-col lg:w-1/2 w-full">
        <DataInput
          :value="internalValue.source"
          type="model"
          required
          validation-rules="required"
          class="w-full mt-4 pr-3"
          label="Quelle"
          name="source"
          gql-query="applicantSources"
          @input="e => updateValue('source', e)"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import salutations from "@/data/enums/Salutation.js";
import salutationTypes from "@/data/enums/SalutationType.js";
import civilStates from "@/data/enums/CivilStatus.js";
import Countries from "@/data/other/Countries.js";
import gql from "graphql-tag";
import CovidVaccinationState from "@/data/enums/CovidVaccinationState";

export default {
  components: {
    DataInput
  },
  props: {
    emailDuplicateCheck: { type: Boolean, default: false },
    value: { type: Object, required: true }
  },
  data: () => ({
    salutations,
    salutationTypes,
    civilStates,
    Countries,
    similarApplicants: {
      data: []
    },
    internalCovidVaccinationState: "UNKNOWN",
    immunizationOptions: Object.entries(
      CovidVaccinationState
    ).map(([state, name]) => ({ label: name, code: state }))
  }),
  computed: {
    internalValue() {
      let val = this.value;
      if (!val.contactData) {
        val.contactData = {};
      }

      if (!val.contactDataCompany) {
        val.contactDataCompany = {};
      }

      if (!val.covidVaccination) {
        val.covidVaccination = {};
      }
      return val;
    },
    vaccinationDateRequired() {
      if (
        ["VACCINATED", "BOOSTERED"].includes(
          this.internalValue.covidVaccination.state
        )
      ) {
        return "required";
      }
      return "";
    },
    testDateRequired() {
      if (this.internalValue.covidVaccination.state === "RECOVERED") {
        return "required";
      }
      return "";
    }
  },
  apollo: {
    applicantsPage: {
      query: gql`
        query ApplicantsPage($filter: ApplicantFilter) {
          applicantsPage(page: 1, size: 5, filter: $filter) {
            total
            results {
              id
              number
              salutation
              firstName
              lastName
            }
          }
        }
      `,
      skip() {
        return (
          !this.emailDuplicateCheck ||
          !this.internalValue.contactData ||
          !this.internalValue.contactData.email ||
          !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            this.internalValue.contactData.email
          )
        );
      },
      variables() {
        return {
          filter: {
            email: this.internalValue.contactData.email
          }
        };
      }
    }
  },
  methods: {
    updateValue(field, value, subField = null) {
      if (field === "birthday" && value === null) {
        value = "0000-01-01T00:00:00Z";
      }
      if (field === "civilStatus" && value === null) {
        value = "NONE_SELECTED";
      }
      if (field === "covidVaccination") {
        if (subField === "state") {
          if (value == null) {
            value = "UNKNOWN";
          }
        }
        this.$set(this.internalValue.covidVaccination, subField, value);
      }
      if (subField) {
        value = Object.assign(this.internalValue[field], {
          [subField]: value === null ? "" : value
        });
      }

      this.$emit(
        "input",
        Object.assign(this.internalValue, {
          [field]: value === null ? "" : value
        })
      );
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }
};
</script>
